<template>
    <div class="relative">
        <h2 class="text-lg my-4" data-cy="deleteText">Are you sure you want to delete this staff member?</h2>
        <p class="text-base text-center text-grey-1 my-8">{{ userName }}</p>
        <div class="flex flex-row justify-center my-4">
            <el-button 
                type="primary"
                @click="deleteHandler"
            >
                Delete User
            </el-button>
            <el-button
                @click="cancelHandler"
                data-cy="cancelHandler"
            >
                Cancel
            </el-button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ModalDeleteUser',
    computed: {
        ...mapState({
            userData: state => state.app.modal.componentData
        }),
        userName() {
            return this.userData.firstName ? `${this.userData.firstName} ${this.userData.lastName}`: ''
        }
    },
    mounted() {
        console.log('monuted() deleteHandler', this.userData)
    },
    methods: {
        deleteHandler() {
            // console.log('deleteHandler')
            this.$root.$emit('delete-user', this.userData)
        },
        cancelHandler() {
            this.$store.commit('MODAL_IS_VISIBLE', false)
        },
    }
}
</script>
